import {setElementVisibility} from '@gongxigames/framework/lib/util/htmlUtils';

export function setVisibleRewind(visible: boolean): void {
    const classList = (document.getElementById('rewindContainer') as HTMLElement)?.classList;

    if (visible && classList.contains('hidden')) {
        classList.remove('hidden');
    } else if(!visible && !classList.contains('hidden')) {
        classList.add('hidden');
    }
}

export function setDisplayRewind(visibility: boolean): void {
    setElementVisibility('rewindContainer', visibility);
}
